import { render, staticRenderFns } from "./ProductListFilters.vue?vue&type=template&id=68705413&"
import script from "./ProductListFilters.vue?vue&type=script&lang=js&"
export * from "./ProductListFilters.vue?vue&type=script&lang=js&"
import style0 from "./ProductListFilters.vue?vue&type=style&index=0&id=68705413&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports